import { TextField } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { FormFillerValues } from '../../FormFiller/types';
import { FieldViewerProps } from './FieldViewer';

export const NumericViewer: React.FC<FieldViewerProps> = ({ field, index }) => {
  const { control } = useFormContext<FormFillerValues>();

  return (
    <Controller
      control={control}
      name={`values.${index}.numerical`}
      render={({ field: { value } }) => (
        <TextField
          label={field.name}
          value={value ?? ''}
          disabled
        />
      )}
    />
  );
};